import Api from '../../app/services/api';

const getWarranty = (id) => Api.get(`/warranty/${id}`);

const getWarranties = (params) => Api.get('/warranty', params);

const addWarantyToCar = (params) => Api.post('/warranty', params);

const deleteWarranty = (id) => Api.delete(`/warranty/${id}`);

const downloadWarranty = (id) => Api.post(`/warranty/download/${id}`, null, null, {
  'Content-Type': 'application/pdf',
}, 'blob');

export {
  getWarranty,
  getWarranties,
  addWarantyToCar,
  deleteWarranty,
  downloadWarranty,
};
